import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ToggleOption from '../../../Form/ToggleOption';
import { getMobileSecondFormRequiredFields, PAYMENT_FIELD_NAME } from '../../util/validators';
import { getPaymentMethodToggleOptions } from '../../util';
import {
  isInsuranceDisabled,
  isPaymentToggleHidden,
  isSelfPayOnly,
} from '../../../../core/util/location';

import SectionTitle from './SectionTitle';
import { colors } from '../../../../constants/colors';

const PaymentSection = styled.div.withConfig({ componentId: 'sc-kjcior-0' })`
  padding-top: 30px;
  background-color: ${colors.grayDim};
`;

const PaymentMethod = styled.div.withConfig({ componentId: 'sc-kjcior-1' })`
  border-top: 1px solid ${colors.greyHounds};
  border-bottom: 1px solid ${colors.greyHounds};
  margin-top: 10px;
  padding: 10px;
  background-color: ${colors.white};
`;

type Props = {
  location: any;
  payment: any;
  initialValues: any;
  form?: any;
};

const HowDoYouWantToPay = ({ location, payment, form, initialValues }: Props) => {
  const { t } = useTranslation(['common', 'bookingWidget']);

  if (isSelfPayOnly(location) || isPaymentToggleHidden(location) || isInsuranceDisabled(location)) {
    return null;
  }

  return (
    <PaymentSection>
      <SectionTitle location={location} />

      <PaymentMethod>
        <ToggleOption
          field={payment}
          id={PAYMENT_FIELD_NAME}
          inputProps={form.getFieldProps(PAYMENT_FIELD_NAME, {
            rules: [
              {
                required: getMobileSecondFormRequiredFields(location, form).includes(
                  PAYMENT_FIELD_NAME
                ),
                message: t('common:required'),
              },
            ],
            initialValue: initialValues[PAYMENT_FIELD_NAME],
          })}
          options={getPaymentMethodToggleOptions(location, t)}
        />
      </PaymentMethod>
    </PaymentSection>
  );
};

export default HowDoYouWantToPay;
